import { render, staticRenderFns } from "./AnalyticsClinicianAndTeam.vue?vue&type=template&id=0f013a98"
import script from "./AnalyticsClinicianAndTeam.vue?vue&type=script&lang=js"
export * from "./AnalyticsClinicianAndTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports